<div >
  <h4 class="m-t-0" mat-dialog-title>{{'administratorDeleteLabel' | translate}}</h4>
  <p> {{'deleteAdministratorStart' | translate}} {{name}} {{'deleteAdministratorEnd' | translate}}</p>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="basic" (click)="closeDialog()">{{'stop' | translate}}</button>
    <button mat-raised-button cdkFocusInitial class="custom-button m-l-10" (click)="deleteUser()">{{'deleteCap' | translate}}</button>
  </div>
</div>